import React, { useState, useEffect, useRef, CSSProperties } from 'react';
import api from '../../services/api';
import { useParams } from 'react-router-dom';
import { Autocomplete, TextField, Box, Modal, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import Logo from '../../img/doc-atento.png';
import QRCode from 'qrcode.react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';


interface DocumentoReaproveitamentoProps {
    idTrabalhador: number;
    idEmpresa: number;
    indexAso: number;
    onClose: any
}

const DocumentoReaproveitamento: React.FC<DocumentoReaproveitamentoProps> = ({
    idTrabalhador,
    idEmpresa,
    indexAso,
    onClose
}
) => {
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [trabalhador, setTrabalhador]: any = useState();
    const [funcaoAtribuida, setFuncaoAtribuida]: any = useState();
    const [empresa, setEmpresa]: any = useState();
    const [liberado, setLiberado] = useState(false);
    const [assinadoTrabalhador, setAssinadoTrabalhador] = useState(false)
    const [reaproveitamento, setReaproveitamento]: any = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [cnae, setCnae]: any = useState()
    const [idArquivo, setIdArquivo]: any = useState();
    const [examesReaproveitamento, setExamesReaproveitamento] = useState([]);
    const [riscosReaproveitamento, setRiscosReaproveitamento] = useState([]);
    const [celular, setCelular] = useState("");
    const [cpf, setCpf] = useState("");
    const [nomeFdt, setNomeFdt] = useState("");
    const [nomeGhe, setNomeGhe]: any = useState('');;
    const [uf, setUf]: any = useState('');
    const [crm, setCRM]: any = useState('');
    const [nomeMedico, setNomeMedico]: any = useState('');
    const [tipoConsulta, setTipoConsulta]: any = useState('');
    const [trabalhoAltura, setTrabalhoAltura]: any = useState('');
    const [trabalhoConfinado, setTrabalhoConfinado]: any = useState('');
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [isDocumentAccessible, setIsDocumentAccessible] = useState(false);
    const [isAsoPronto, setIsAsoPronto] = useState(false);
    const contentRef = useRef(null);

    // URL para o QRCode LOCAL testes:
    const qrCodeUrl = `https://webhomol.meupgr.com.br/informacoes-documento-empresa/${idEmpresa}/trabalhador/${idTrabalhador}/doc/${indexAso}`;


    useEffect(() => {
        const fetchData = async () => {
            try {
                await loadReaproveitamento()
                await loadExames()
            } catch (error) {
                console.error('Erro ao buscar os dados:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    // Método para buscar os exames do vinculados ao indexAso
    const loadExames = async () => {
        try {
            const { data } = await api.get(`buscar-itens-reaproveitamento-empresa/${indexAso}`);
            setExamesReaproveitamento(data.exames);
            setRiscosReaproveitamento(data.riscos);
        } catch (error) {
            console.error(error);
        }
    };

    const loadReaproveitamento = async () => {
        try {
            const { data } = await api.get(`reaproveitamento/${indexAso}`);
            const reaproveitamento = data.reaproveitamento;
            const cnae = data.cnae;

            setReaproveitamento(reaproveitamento);
            setIdArquivo(reaproveitamento.id_arquivo);
            setLiberado(reaproveitamento.liberado)
            setAssinadoTrabalhador(reaproveitamento.assinado_trabalhador)
            setIsAsoPronto(reaproveitamento.is_aso_pronto);

            setNomeFdt(reaproveitamento.frente_de_trabalho || 'Não adicionada');
            setNomeGhe(reaproveitamento.ghe || 'Não adicionada');
            setTrabalhador(reaproveitamento.pgrTrabalhador);
            setEmpresa(reaproveitamento.empresa);

            setCpf(reaproveitamento.pgrTrabalhador?.cpf || '');
            setCelular(reaproveitamento.pgrTrabalhador?.celular || '');

            setFuncaoAtribuida(reaproveitamento.funcao);
            setTipoConsulta(reaproveitamento.tipo_consulta);
            setTrabalhoAltura(reaproveitamento.trabalho_altura);
            setTrabalhoConfinado(reaproveitamento.trabalho_confinado);

            setNomeMedico(reaproveitamento.nome_medico);
            setCRM(reaproveitamento.crm_medico);
            setUf(reaproveitamento.uf_crm);


            setCnae(cnae)

        } catch (error) {
            console.error(error);
        }
    };


    // Método para salvar o pdf final no bucket e enviar para assinatura
    const handleSendPdf = async () => {
        setIsSubmitting(true);
        try {
            const pdfBytes = await generatePDF();
            const nomeDoPdf = `ASO-APROVEITAMENTO_${indexAso}_${trabalhador.nome}.pdf`;

            // const data = {
            //     idEmpresa: empresa.id,
            //     nomeDoPdf: nomeDoPdf,
            //     pdfBytes: Array.from(new Uint8Array(pdfBytes)),
            //     idReaproveitamento: indexAso,
            //     idTrabalhador: trabalhador.id
            // };
            // await api.post('upload-documento-reaproveitamento', data);

            const blob = new Blob([pdfBytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = nomeDoPdf;
            link.click();

            URL.revokeObjectURL(url);
            onClose()
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    };

    const generatePDF = async () => {
        const content: any = contentRef.current;

        if (!content) {
            console.error('Content ref is null. Make sure the component has rendered.');
            return;
        }

        const doc: any = new jsPDF();
        const pages = content.querySelectorAll('.page');

        if (pages) {
            pages.forEach((element: any) => {
                element.style.backgroundImage = 'none';
            });
        }

        if (pages.length === 0) {
            console.error('No pages found. Make sure the content has a class "page".');
            return;
        }

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];
            const isLandscape = page.classList.contains('landscape');
            const orientation = isLandscape ? 'landscape' : 'portrait';

            if (i > 0) {
                doc.addPage([297, 210], orientation);
            }

            const canvas = await html2canvas(page, { scale: 1 });
            const imgData = canvas.toDataURL('image/jpeg');
            doc.addImage(imgData, 'JPEG', 0, 0);
        }

        const pdfBytes = doc.output('arraybuffer');

        if (!pdfBytes) {
            console.error('Failed to generate PDF bytes.');
        } else {
            console.log('PDF bytes generated successfully.');
        }

        return pdfBytes;
    };




    // Método para exibição da data de realização do exame no PDF
    const subtrairNoveMeses = (data: string): string => {
        const dataLuxon = DateTime.fromISO(data);
    
        if (!dataLuxon.isValid) {
            throw new Error('Data inválida');
        }
    
        // Subtraindo 9 meses, mas mantendo o mesmo dia, caso o mês anterior tenha menos dias
        const novaData = dataLuxon.minus({ months: 9 }).set({ day: Math.min(dataLuxon.day, dataLuxon.minus({ months: 9 }).daysInMonth) });
    
        return novaData.toFormat('dd/MM/yyyy');
    };

    // Formatar Data do documento
    const formatarData = (data: string) => {
        if (!data) return '';
        const isFormatted = data.includes('/');
        if (isFormatted) {
            return data;
        } else {
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        }
    };

    const handleClosePdf = () => setOpenPdfModal(false);

    const handleOpenPdf = async () => {
        setOpenPdfModal(true);
    };

    const style = {
        position: 'absolute',
        top: '80%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 1123,
        height: 1123,
    };


    return (
        <Modal
            id="modal-pdf"
            open={true}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ overflow: 'auto' }}
            className={`${isDocumentAccessible ? 'teste' : 'planoModal'}`}
            slotProps={{
                backdrop: {
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
                }
            }}
        >
            <Box sx={style}>
                <div ref={contentRef} id="content-pdf">
                    <div className="page">
                        <div className="page-content capa">
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '300px', border: '0.5px solid #C0C0C0' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                        <img src={Logo} alt="logo" style={{ width: '95%', height: '60px', marginTop: '10px', padding: '5px' }} />
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                        <p style={{ fontSize: '11px', margin: 0 }}>ATENTO MEDICINA DO TRABALHO LTDA</p>
                                        <p style={{ fontSize: '10px', margin: 0 }}>CNPJ 11.509.053/0001-59</p>
                                        <p style={{ fontSize: '9px', margin: 0 }}>41 3642-6495</p>
                                        <p style={{ fontSize: '8px', margin: 0 }}>Rua Heitor Alves Guimarães, 495 - ARAUCÁRIA - PARANÁ</p>
                                    </div>
                                </div>
                                <div style={{ flex: 1, border: '0.5px solid #C0C0C0', borderLeft: 'none' }}>
                                    <p style={{ fontSize: '8px', margin: '1px' }}>
                                        ESTE DOCUMENTO ATENDE ÁS EXIGÊNCIAS DA NR-7, APROVADAS PELA PORTARIA Nº3.214, DE 8 DE JUNHO DE 1978,
                                        3164/82,12/83,24/94 E 08/96 DO MINISTÉRIO DO TRABALHO E EMPREGO PARA FINS DE EXAME.
                                    </p>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '70%' }}>
                                            <p style={{ fontSize: '11px', margin: 0 }}><b>ATESTADO DE SAÚDE OCUPACIONAL (Nº 17)</b></p>
                                            <p style={{ fontSize: '11px', margin: 0 }}><b>{tipoConsulta}</b></p>
                                            <p style={{ fontSize: '10px', margin: 0 }}>
                                                ASO Gerado por reaproveitamento de exames
                                            </p>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30%' }}>
                                            <QRCode value={qrCodeUrl} size={110} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* DIV PRINCIPAL */}
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                <div style={{ display: 'flex', width: '23%', flexDirection: 'column' }}>
                                    <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>EMPRESA:</b></p>
                                    <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>ENDEREÇO:</b></p>
                                    <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>RAMO DE ATIVIDADE:</b></p>
                                    <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>GRAU DE RISCO:</b></p>
                                </div>
                                <div style={{ display: 'flex', width: '77%', flexDirection: 'column' }}>
                                    {empresa && (
                                        <>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>{empresa.nome} <b style={{ marginLeft: '15px' }}>CNPJ: </b>{empresa.cnpj} </p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>{empresa.endereco} - {empresa.numero}</p>
                                            <p style={{ fontSize: '8px', margin: '2px' }}>{cnae.cnae} - {cnae.nome}</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>{cnae.g_risco}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                            {/* DIV PRINCIPAL */}
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                <div style={{ display: 'flex', width: '23%', flexDirection: 'column' }}>
                                    <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>TRABALHADOR(a):</b></p>
                                    <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>CPF:</b></p>
                                    <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>DATA DE NASCIMENTO:</b></p>
                                    <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>FUNÇÃO:</b></p>
                                    <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>GHE (SETOR):</b></p>
                                    <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>FRENTE DE TRABALHO:</b></p>
                                </div>
                                <div style={{ display: 'flex', width: '77%', flexDirection: 'column' }}>
                                    {trabalhador && (
                                        <>
                                            <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhador.nome}</p>
                                            <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhador.cpf} <b style={{ marginLeft: '15px' }}>RG: </b>123456123 <b style={{ marginLeft: '15px' }}>SEXO: </b> MASCULINO</p>
                                            <p style={{ fontSize: '10px', margin: '1px' }}>28/05/1998 <b style={{ marginLeft: '15px' }}>IDADE: </b> 26 anos</p>
                                            <p style={{ fontSize: '8px', margin: '1px' }}>{funcaoAtribuida ? funcaoAtribuida.nome : 'null'}</p>
                                            <p style={{ fontSize: '10px', margin: '1px' }}>{nomeGhe}</p>
                                            <p style={{ fontSize: '10px', margin: '1px' }}>{nomeFdt}</p></>
                                    )}
                                </div>
                            </div>
                            {/* DIV PRINCIPAL */}
                            <div style={{ width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={3} style={{ textAlign: 'left', padding: '5px', fontSize: '10px' }}>
                                                <b>RISCOS OCUPACIONAIS</b>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {riscosReaproveitamento.map((risco: any, index: number) => (
                                            <tr key={index}>
                                                <td style={{ width: '30%', border: '0.5px solid #C0C0C0', padding: '2px', fontSize: '7px' }}>
                                                    {risco.categoria}
                                                </td>
                                                <td style={{ width: '70%', border: '0.5px solid #C0C0C0', padding: '2px', fontSize: '7px' }}>
                                                    <ul style={{ margin: '0', paddingLeft: '20px' }}>
                                                        <li>{risco.nome_risco}</li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* DIV PRINCIPAL */}
                            <div style={{ width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={5} style={{ textAlign: 'left', padding: '5px', fontSize: '10px' }}>
                                                <b>EXAMES REALIZADOS</b>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.from({ length: Math.ceil(examesReaproveitamento.length / 20) }).map((_, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {Array.from({ length: 4 }).map((_, colIndex) => {
                                                    const startIndex = rowIndex * 20 + colIndex * 5;
                                                    const hasExams = examesReaproveitamento.slice(startIndex, startIndex + 5).length > 0;
                                                    return hasExams ? (
                                                        <td key={colIndex} style={{ border: '0.5px solid #C0C0C0', fontSize: '7px', padding: '5px', verticalAlign: 'top' }}>
                                                            {Array.from({ length: 5 }).map((_, subIndex) => {
                                                                const examIndex = startIndex + subIndex;
                                                                const exame: any = examesReaproveitamento[examIndex];
                                                                return (
                                                                    <div key={subIndex} style={{ marginBottom: '5px' }}>
                                                                        {exame ? (
                                                                            <span>
                                                                                <b>{subtrairNoveMeses(exame.data_validade)}</b> {exame.exame.nome}
                                                                            </span>
                                                                        ) : null}
                                                                    </div>
                                                                );
                                                            })}
                                                        </td>
                                                    ) : null;
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* DIV PRINCIPAL */}

                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none', justifyContent: !isAsoPronto ? 'space-between' : 'center', }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '50%', padding: '10px' }}>
                                    <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>NOME DO MÉDICO EXAMINADOR COM CRM,</p>
                                    <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>CARIMBO E ASSINATURA</p>
                                    <p style={{ fontSize: '7px', fontWeight: 'bold', margin: '3px', textAlign: 'center' }}>Assinado digitalmente por: </p>
                                    <p style={{ fontSize: '7px', margin: '1px', textAlign: 'center' }}>MAURICIO CHERATZKI:78083567949</p>
                                    <p style={{ fontSize: '7px', margin: '1px', textAlign: 'center' }}>Autenticado por AC Certisign RFB G5 </p>
                                    <hr style={{ width: '50%', borderColor: 'black', marginTop: '30px', marginBottom: 0 }} />
                                    <p style={{ fontSize: '7px', margin: 0, textAlign: 'center' }}>Maurício Cheratzki CRM 15302 /PR (41) 3642-6495</p>
                                </div>
                                {!isAsoPronto && (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '50%', padding: '10px' }}>
                                        <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>NOME DO MÉDICO DO TRABALHO COORDENADOR DO PCMSO,</p>
                                        <p style={{ fontSize: '10px', margin: '2px', textAlign: 'center' }}>COM CRM E ESTADO EMISSOR</p>
                                        <hr style={{ width: '50%', borderColor: 'black', marginTop: '30px', marginBottom: 0 }} />
                                        <p style={{ fontSize: '7px', margin: 0, textAlign: 'center' }}>Dr. {nomeMedico} CRM {crm} / {uf}</p>
                                    </div>
                                )}
                            </div>

                            {/* DIV PRINCIPAL */}
                            {!isAsoPronto && (
                                <>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ width: '50%' }}>
                                            <h6 style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>APTIDÃO</h6>
                                            <h6 style={{ fontSize: '10px', marginLeft: '5px' }}>APTO PARA FUNÇÃO [ {tipoConsulta === '1' ? 'x' : ''} ]</h6>
                                        </div>
                                        <div style={{ width: '50%' }}>
                                            <h6 style={{ fontSize: '10px' }}>INAPTO PARA A FUNÇÃO [ {tipoConsulta === '2' ? 'x' : ''} ]</h6>
                                        </div>
                                    </div>
                                    {/* DIV PRINCIPAL */}
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ width: '30%' }}>
                                            <h6 style={{ fontSize: '11px', margin: '2px', marginLeft: '5px' }}>TRABALHOS ESPECIAIS</h6>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>Trabalho em Altura:</p>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>Trabalho em Espaço Confinado:</p>
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura == 1 ? 'X' : ''} ] APTO</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado == 1 ? 'X' : ''} ] APTO</p>
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura == 2 ? 'X' : ''} ] INAPTO</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado == 2 ? 'X' : ''} ] INAPTO</p>
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura == 3 ? 'X' : ''} ] N/A</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado == 3 ? 'X' : ''} ] N/A</p>
                                        </div>
                                    </div>
                                </>
                            )

                            }

                            {/* DIV PRINCIPAL */}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                <h6 style={{ fontSize: '12px', margin: '2px' }}>ASSINATURA DO EMPREGADO</h6>
                                <h6 style={{ fontSize: '12px', margin: '2px' }}>RECEBI CÓPIA DO ASO NESTA DATA</h6>
                                {assinadoTrabalhador && (
                                    <>
                                        <p style={{ fontSize: '7px', fontWeight: 'bold', margin: '3px', textAlign: 'center' }}>Assinado digitalmente por: </p>
                                        <p style={{ fontSize: '7px', margin: '1px', textAlign: 'center' }}>{trabalhador?.nome} - {trabalhador?.cpf} </p>
                                    </>
                                )}
                                <hr style={{ width: '50%', borderColor: 'black', marginTop: '30px', marginBottom: 0 }}></hr>
                                {trabalhador && (
                                    <h6 style={{ fontSize: '10px', margin: '2px' }}>{trabalhador.nome}</h6>
                                )}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '30px' }}>
                                    <p style={{ fontSize: '10px', margin: '2px' }}>DATA DE EMISSÃO DO ASO:</p>
                                    <p style={{ fontSize: '10px', margin: '2px' }}>{formatarData(new Date().toISOString().split('T')[0])}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <OverlayTrigger placement="top"
                    overlay={
                        <Tooltip id={`tooltip-enviar-assinatura`}>
                            Baixar documento
                        </Tooltip>
                    }>
                    <Button className='btn-main mt-4' style={{ width: '250px', position: 'fixed', top: '1px', right: '-100px' }} onClick={handleSendPdf} disabled={isSubmitting}>
                        {isSubmitting ? (
                            'Enviando...'
                        ) : (
                            'Baixar Documento'
                        )}
                    </Button>
                </OverlayTrigger>
            </Box>
        </Modal>

    );
};

export default DocumentoReaproveitamento;
